export default (theme) => ({
    root: {
        width: '100%',
        height: '100%',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '12px',
        cusros: 'default',
        overflowY: 'auto',
        ...theme.utils.scrollbar,
    },
    boxContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '8px',
        padding: '24px 0',
        border: `2px solid ${theme.colors.grey[50]}`,
    },
    boxValue: {},
    boxLabel: {
        textAlign: 'center',
    },
});
